import { render, staticRenderFns } from "./SalidasTable.vue?vue&type=template&id=5cb2217b&scoped=true"
import script from "./SalidasTable.vue?vue&type=script&lang=ts"
export * from "./SalidasTable.vue?vue&type=script&lang=ts"
import style0 from "./SalidasTable.vue?vue&type=style&index=0&id=5cb2217b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb2217b",
  null
  
)

export default component.exports